import { userKey } from '@/config';
import Cookie from './cookie';
import store from '@/store';

function getUser() {
  return JSON.parse(Cookie.get(userKey));
}

function setUser(user) {
  store.dispatch('setUser', user);
  return Cookie.set(userKey, JSON.stringify(user));
}

function removeUser() {
  return Cookie.remove(userKey);
}

export {
  getUser,
  setUser,
  removeUser
};